import type { Middleware } from 'redux';

import { getTargetScopeFromAction } from '../actions/scopedActions';
import { scopedStoreManager } from '../store/scopedStoreManager';

export const scopeMiddleware = (middleware: Middleware) => {
    return (store: any) => (next: any) => (action: any) => {
        const targetScope = getTargetScopeFromAction(action);
        if (targetScope === undefined) {
            // eslint-disable-next-line no-console
            console.error('Non scoped Action Detected', action);
        }

        // TODO: Decide how middlewares should run when there's no target Scope on the action.
        // For the time being this will happens on the @@init action or on actions dispatched on a RawStateProvider
        // for now we are sending undefined which will cause the middleware to operate on the Primary Scope.
        const scopedStore = scopedStoreManager.getStore(store, targetScope || undefined);

        return middleware(scopedStore)(next)(action);
    };
};
